import React, { useState, useEffect, useRef } from 'react';
import './ModelSwitcherDropdown.css';

function ModelSwitcherDropdown({ activeModel, switchModel }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Mapping of backend keys to display names
  const modelNames = {
    'CUSTOM': 'Select KP',
    'HLC': 'HLC Model',
    'CPA': 'CPA Model',
    'LCOS': 'LCOS Model',
    'HTT': 'HTT Model',
    'HEPI': 'HEPI Model'
  };

  const handleDropdownClick = () => {
    setIsOpen(!isOpen);
  };

  const handleModelClick = (model) => {
    switchModel(model); // Pass the key to the switchModel function
    setIsOpen(false); // Close dropdown after selection
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false); // Close dropdown if clicked outside
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // If activeModel is not in the mapping, show a default placeholder
  const displayModelName = modelNames[activeModel] || "Select KP";

  return (
    <div className="model-switcher-container" ref={dropdownRef}>
      <button className="model-switcher-button" onClick={handleDropdownClick}>
        {displayModelName} {/* Display the user-friendly name or placeholder */}
        <span className="dropdown-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" className="icon-md text-token-text-tertiary">
            <path fill="currentColor" fillRule="evenodd" d="M5.293 9.293a1 1 0 0 1 1.414 0L12 14.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414" clipRule="evenodd"></path>
          </svg>
        </span>
      </button>
      {isOpen && (
        <div className="dropdown-content">
          <div className={`dropdown-item ${activeModel === 'CUSTOM' ? 'active' : ''}`} onClick={() => handleModelClick('CUSTOM')}>
            <span className="icon">⭐</span>
            <div className="model-info">
              <div className="model-name">Custom Model</div>
              <div className="model-desc">Customize your own knowledge pack!</div>
            </div>
          </div>
          <div className={`dropdown-item ${activeModel === 'HLC' ? 'active' : ''}`} onClick={() => handleModelClick('HLC')}>
            <span className="icon">⚡</span>
            <div className="model-info">
              <div className="model-name">HLC Model</div>
              <div className="model-desc">Huntington Learning Center Ops</div>
            </div>
          </div>
          <div className={`dropdown-item ${activeModel === 'CPA' ? 'active' : ''}`} onClick={() => handleModelClick('CPA')}>
            <span className="icon">🎮</span>
            <div className="model-info">
              <div className="model-name">CPA Model</div>
              <div className="model-desc">CPA Exam Assistant</div>
            </div>
          </div>
          <div className={`dropdown-item ${activeModel === 'LCOS' ? 'active' : ''}`} onClick={() => handleModelClick('LCOS')}>
            <span className="icon">⚡</span>
            <div className="model-info">
              <div className="model-name">LCOS Model</div>
              <div className="model-desc">Learning Center Operations Systems</div>
            </div>
          </div>
          <div className={`dropdown-item ${activeModel === 'HTT' ? 'active' : ''}`} onClick={() => handleModelClick('HTT')}>
            <span className="icon">⚡</span>
            <div className="model-info">
              <div className="model-name">HTT Model</div>
              <div className="model-desc">HLC Teacher Training</div>
            </div>
          </div>
          <div className={`dropdown-item ${activeModel === 'HEPI' ? 'active' : ''}`} onClick={() => handleModelClick('HEPI')}>
            <span className="icon">⚡</span>
            <div className="model-info">
              <div className="model-name">HEPI Model</div>
              <div className="model-desc">HLC Exam Prep Instructions</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ModelSwitcherDropdown;








